import { CustomerType, getCustomerResponseSchema } from './getCustomerResponse';
import { guestProfileSchema } from './guestProfile';

const CUSTOMER_TYPE_TO_GUEST_PROFILE = {
  [CustomerType.US_CFA]: 'customers',
  [CustomerType.US_ANONYMOUS]: 'anonymousCustomers',
  CUSTOMER_TYPE_US_CFA: 'customers',
  CUSTOMER_TYPE_US_ANONYMOUS: 'anonymousCustomers',
};

function buildDisplayName(name) {
  if (!name) {
    return undefined;
  }

  const { givenName, familyName } = name;
  const displayName = [givenName, familyName].filter(Boolean).join(' ').trim();

  return displayName || undefined;
}

function mapCustomerType(customerType) {
  return CUSTOMER_TYPE_TO_GUEST_PROFILE[customerType] ?? 'anonymous';
}

function mapEmails(customer) {
  const emails = [];

  if (customer.emailAddress?.value) {
    emails.push({
      value: customer.emailAddress.value,
      primary: true,
    });
  }

  if (customer.secondaryEmail?.value) {
    emails.push({
      value: customer.secondaryEmail.value,
      primary: false,
    });
  }

  return emails.length > 0 ? emails : undefined;
}

function mapPhoneNumbers(customer) {
  const phoneValue = customer.phoneNumber?.value?.base;

  if (!phoneValue) {
    return undefined;
  }

  return [{ value: phoneValue, type: 'Primary' }];
}

export function mapGetCustomerResponseToGuestProfile(response) {
  const parsed = getCustomerResponseSchema.parse(response);
  const { customer } = parsed;

  if (!customer) {
    return guestProfileSchema.parse({});
  }

  const { id, name, customerType } = customer;
  const givenName = name?.givenName;
  const familyName = name?.familyName;

  return guestProfileSchema.parse({
    uid: id,
    name: name
      ? {
          givenName,
          familyName,
          displayName: buildDisplayName(name),
        }
      : undefined,
    emails: mapEmails(customer),
    phoneNumbers: mapPhoneNumbers(customer),
    customerType: mapCustomerType(customerType),
  });
}

export default mapGetCustomerResponseToGuestProfile;
